export enum CurrencySymbol {
  Eur = "€",
}
